import { Schema } from 'yup';
import { messages } from '../messages';

function necessaryField({ field }: { field: string }) {
  return messages([
    { errorCode: 'FRONT-RE-NECESSARY_FIELD' },
    { subject: field, subjectType: 'field' },
  ]);
}

export function validationSchema({
  schema,
  values,
}: {
  schema: Schema<any>;
  values: any;
}) {
  schema
    .validate(values)
    .then(() => {})
    .catch((error) => {
      necessaryField({ field: error.message });
    });
}

export const formValidations = {
  necessaryField,
  validationSchema,
};
